import React from 'react';
import PageHeader from 'react-bootstrap/lib/PageHeader';
import Panel from 'react-bootstrap/lib/Panel';
import Form from 'react-bootstrap/lib/Form';
import Row from '@coxautokc/fusion-ui-components/lib/Row';
import Col from '@coxautokc/fusion-ui-components/lib/Col';
import Button from '@coxautokc/fusion-ui-components/lib/Button';
import SelectInput from '@coxautokc/fusion-ui-components/lib/SelectInput';
import TextInput from '@coxautokc/fusion-ui-components/lib/TextInput';

export default class FormValidationExamplePage extends React.Component {
  state = {
    errors: {},
    customer: {
      firstName: '',
      vehicle: ''
    }
  };

  // Since this won't change, no need to place in state.
  vehicles = [
    { label: 'Accent', value: 'accent' },
    { label: 'Elantra', value: 'elantra' },
    { label: 'Sonata', value: 'sonata' },
    { label: 'Tucson', value: 'tucson' },
    { label: 'Veloster', value: 'veloster' }
  ];

  onChange = (event, isValid) => {
    const { name, value } = event.target;
    if (!name) throw new Error('The name prop is required on all form inputs');

    // state is immutable, so create a copy
    const { errors, customer } = Object.assign({}, this.state);

    // then can change values on the copy.
    errors[name] = isValid ? undefined : true;
    customer[name] = value;
    this.setState({ errors, customer });
  };

  onSubmit = event => {
    event.preventDefault();
    console.log(this.state); // eslint-disable-line no-console
  };

  formIsValid() {
    const { errors, customer } = this.state;
    const { firstName, vehicle } = customer;

    // If errors object has any defined properties, then errors exist.
    const errorsExist =
      Object.keys(errors).length === 0 && errors.constructor === Object;

    // Form is valid if no errors exist and each required field is populated
    return !errorsExist && firstName && vehicle;
  }

  render() {
    const { firstName, vehicle } = this.state.customer;

    return (
      <div>
        <PageHeader>Example: Form Validation</PageHeader>
        <p>This form displays current form standards:</p>
        <ol>
          <li>Label should display above the input.</li>
          <li>
            Required fields should be marked with a red asterisk to the right of
            the label.
          </li>
          <li>Input should display placeholder that correlates with label.</li>
          <li>
            Label should be associated with the input via an htmlFor (for
            accessibility and usability purposes)
          </li>
          <li>A maxLength should be provided on all TextInputs</li>
          <li>Validate fields on blur.</li>
          <li>Error should display in red below the input</li>
          <li>
            After a blur, validate on keypress so that the error is removed the
            moment the field is invalid.
          </li>
          <li>Dropdown values should be sorted alphabetically</li>
          <li>
            Disable the submit button until the form is in a valid state for
            submission.
          </li>
          <li>
            Submit the form on enter key press. Note the onSubmit on
            &lt;form&gt; to support this.
          </li>
        </ol>

        <p>
          This form uses the &lt;TextInput&gt; and &lt;SelectInput&gt;
          components from{' '}
          <a href="https://ghe.coxautoinc.com/coxauto-ui/fusion-ui-components">
            Fusion-UI
          </a>{' '}
          which handle #1 - #8 above automatically. So you only have to handle
          #9 - #11! 😀
        </p>
        <Panel>
          <Row>
            <Col sm={12} md={6} lg={6}>
              <Form noValidate onSubmit={this.onSubmit}>
                <TextInput
                  htmlId="testformFirstName"
                  label="First Name"
                  name="firstName"
                  maxLength={30}
                  onChange={this.onChange}
                  value={firstName}
                  required
                />
                <SelectInput
                  htmlId="testformVehicle"
                  options={this.vehicles}
                  onChange={this.onChange}
                  label="Vehicle"
                  name="vehicle"
                  value={vehicle}
                  required
                />
                <Button
                  htmlId="submitTestForm"
                  bsStyle="primary"
                  type="submit"
                  disabled={!this.formIsValid()}
                >
                  Submit
                </Button>
              </Form>
            </Col>
            <Col sm={12} md={6} lg={6}>
              <pre>{JSON.stringify(this.state, null, 2)}</pre>
            </Col>
          </Row>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/FormValidationExamplePage/FormValidationExamplePage.js